import { createSlice } from "@reduxjs/toolkit";

const sessionSlice = createSlice({
  name: "session",
  initialState: {
    isSessionExpired: false,
  },
  reducers: {
    setSessionExpired: (state, action) => {
      state.isSessionExpired = action.payload;
    },
  },
});

export const { setSessionExpired } = sessionSlice.actions;
export default sessionSlice.reducer;
